'use strict';
const options_collection = {
  collectionsLoadMore: '.collections-load-more',
  rangeSlider: '.price-range .range-slider',
  rangeSliderMin: '.range-slider-min',
  rangeSliderMax: '.range-slider-max',
  minPriceRange: '.min-price-range',
  maxPriceRange: '.max-price-range',
  collectionSidebar: '#CollectionSidebar',
  collectionFilterBlocks: '.filter-blocks',
  productgridcontainer: '#productgridcontainer',
  collectionFiltersForm: '#CollectionFiltersForm',
  section: '.sec__collection-main',
};

class CollectionControl extends HTMLElement {
  connectedCallback() {
    this.setAttribute('role', 'button');
    if (!this.hasAttribute('tabindex')) this.tabIndex = 0;
    if (this._broekKeyboard) return;
    this._broekKeyboard = true;
    this.addEventListener('keydown', event => {
      if (event.target !== this || !['Enter', ' '].includes(event.key)) return;
      event.preventDefault();
      if (this.getAttribute('aria-disabled') !== 'true' && !event.repeat) this.click();
    });
  }
}

class BtnFilter extends CollectionControl {
  constructor() {
    super();
    this.addEventListener('click', this.onOpen.bind(this), false);
  }
  onOpen() {
    const sidebar = document.getElementById('CollectionSidebar');
    if (!sidebar) return;
    if (!sidebar.classList.contains('open')) {
      sidebar.classList.add('open');
      document.documentElement.classList.add('open-drawer', 'open-sidebar');
      root.style.setProperty('padding-right', getScrollBarWidth.init() + 'px');
      this.classList.add('open');
    } else {
      sidebar.classList.remove('open');
      document.documentElement.classList.remove('open-drawer', 'open-sidebar');
      root.style.removeProperty('padding-right');
      this.classList.remove('open');
    }
  }
}
customElements.define('btn-filter', BtnFilter);
class CloseFilter extends CollectionControl {
  constructor() {
    super();
    this.addEventListener('click', this.onClick.bind(this), false);
  }
  onClick() {
    this.onClose();
  }
  onClose() {
    const sidebar = document.getElementById('CollectionSidebar');
    if (!sidebar) return;
    sidebar.classList.remove('open');
    document.documentElement.classList.remove('open-drawer', 'open-sidebar');
    document.querySelector('.btn-filter')?.classList.remove('open');
    root.style.removeProperty('padding-right');
  }
}
customElements.define('close-filter', CloseFilter);

class FacetApplyCanvas extends CloseFilter {
  onClick(event) {
    event.preventDefault();
    const form = document.querySelector(options_collection.collectionFiltersForm);
    if (!form) {
      this.onClose();
      return;
    }
    eventCollectionShopify.ionRangeSlider();
    // The AJAX form handler closes the current drawer only after a successful refresh.
    if (form.dataset.broekPriceBound) form.requestSubmit();
  }
}
customElements.define('facet-apply-canvas', FacetApplyCanvas);

class GridMode extends CollectionControl {
  constructor() {
    super();
    this.addEventListener('click', this.gridMode.bind(this), false);
  }
  async gridMode() {
    if (this.classList.contains('active')) return;
    const view_mode = this.getAttribute('data-grid-mode');
    if (view_mode == 1) return;
  await Motion.animate(
      document.querySelectorAll(
        'motion-element.product-item__wrapper.slide_in'
      ),
      {
        transform: ['translateY(0)', 'translateY(3.5rem)'],
        opacity: [1, 0.01],
        visibility: ['visible', 'hidden'],
      },
      {
        duration: 0.3,
        delay: Motion.stagger(0.05),
        easing: [0, 0, 0.3, 1],
      }
    );


    for (var item of document.querySelectorAll('grid-mode')) {
      item.classList.remove('active');
    }
    const container_switch = document.querySelector(
      '.container-products-switch'
    );
    this.classList.add('active');
    const data_view_mode = container_switch.getAttribute('data-view-mode');
    container_switch.classList.remove('grid-columns-' + data_view_mode);
    container_switch.setAttribute('data-view-mode', view_mode);
    container_switch.classList.add('grid-columns-' + view_mode);
    Motion.animate(
      document.querySelectorAll(
        'motion-element.product-item__wrapper.slide_in'
      ),
      {
        transform: ['translateY(3.5rem)', 'translateY(0)'],
        opacity: [0.01, 1],
        visibility: ['hidden', 'visible'],
      },
      {
        duration: 0.3,
        delay: Motion.stagger(0.1),
        easing: [0, 0, 0.3, 1],
      }
    );
  }
}
customElements.define('grid-mode', GridMode);

class ViewMode extends CollectionControl {
  constructor() {
    super();
    this.addEventListener('click', this.viewMode.bind(this), false);
  }
  viewMode() {
    const view_mode = this.getAttribute('data-view');
    if (this.classList.contains('actived')) return;
    var queryString = window.location.search;
    queryString = eventCollectionShopify.removeParam('view', queryString);
    if (view_mode == 'list') {
      var searchParams = queryString.replace('?', '') + '&view=list';
    } else {
      var searchParams = queryString.replace('?', '') + '&view=grid';
    }
    const url = eventCollectionShopify.renderUrl(searchParams);
    eventCollectionShopify.renderSectionFilter(url, searchParams);
  }
}
customElements.define('view-mode', ViewMode);

class FilterItem extends CollectionControl {
  constructor() {
    super();
    this.addEventListener('click', this.filterItem.bind(this), false);
  }
  filterItem() {
    if (this.querySelector('.tooltip')) {
      this.querySelector('.tooltip').classList.toggle('current-filter');
    } else {
      if (this.closest('li')) {
        this.closest('li').classList.toggle('current-filter');
      }
    }
    const url = this.getAttribute('data-href');
    eventCollectionShopify.renderSectionFilter(url);
  }
}
customElements.define('filter-item', FilterItem);

class FacetClearAll extends CloseFilter {
  constructor() {
    super();
    this.addEventListener('click', this.filterItem.bind(this), false);
  }
  filterItem() {
    const url = this.getAttribute('data-href');
    eventCollectionShopify.renderSectionFilter(url);
    this.onClose();
  }
}
customElements.define('facet-clear-all', FacetClearAll);

class FilterSort extends CollectionControl {
  constructor() {
    super();
    this.addEventListener('click', this.filterSort.bind(this), false);
  }
  filterSort() {
    const value = this.getAttribute('value');
    let queryString = window.location.search;
    queryString = eventCollectionShopify.removeParam('sort_by', queryString);
    const searchParams = queryString.replace('?', '') + '&sort_by=' + value;
    const url = eventCollectionShopify.renderUrl(searchParams);
    eventCollectionShopify.renderSectionFilter(url, searchParams);
  }
}
customElements.define('filter-sort', FilterSort);

class SelectSorter extends CollectionControl {
  constructor() {
    super();
    this.addEventListener('click', this.activeFilterSort.bind(this), false);
  }
  activeFilterSort() {
    if (this.closest('.select-custom').classList.contains('active')) {
      this.closest('.select-custom').classList.remove('active');
    } else {
      this.closest('.select-custom').classList.add('active');
    }
  }
}
customElements.define('select-sorter', SelectSorter);

var eventCollectionShopify = (function () {
  return {
    init: function () {
      this.ionRangeSlider();
      let windowWidth = window.innerWidth;
      if (windowWidth <= 1024) {
        const horizontal = document.querySelector('.horizontal-filter');
        if (horizontal) {
          const collapsible = document.querySelectorAll('collapsible-block');
          collapsible.forEach((e) => {
            e.classList.add('active');
          });
        }
      }
    },

    ionRangeSlider: function () {
      const form = document.querySelector(options_collection.collectionFiltersForm);
      if (!form || form.dataset.broekPriceBound) return;
      const minPrice = form.querySelector(options_collection.minPriceRange);
      const maxPrice = form.querySelector(options_collection.maxPriceRange);
      const minRange = form.querySelector(options_collection.rangeSliderMin);
      const maxRange = form.querySelector(options_collection.rangeSliderMax);
      if (!minPrice || !maxPrice || !minRange || !maxRange) return;
      form.dataset.broekPriceBound = 'true';
      const maximum = Number(maxRange.max) || 0;
      const sync = changed => {
        let low = Number(minPrice.value);
        let high = maxPrice.value.trim() === '' ? maximum : Number(maxPrice.value);
        low = Number.isFinite(low) ? Math.max(0, Math.min(maximum, low)) : 0;
        high = Number.isFinite(high) ? Math.max(0, Math.min(maximum, high)) : maximum;
        if (low > high) { if (changed === minPrice) high = low; else low = high; }
        minPrice.value = String(low); maxPrice.value = String(high);
        minRange.value = String(low); maxRange.value = String(high);
        const bar = form.querySelector('.drop-range');
        bar?.style.setProperty('--range-from', (maximum ? low / maximum * 100 : 0) + '%');
        bar?.style.setProperty('--range-to', (maximum ? high / maximum * 100 : 100) + '%');
        form.querySelector('.price-lable .min').innerHTML = Shopify.formatMoney(Math.round(low * 100), cartStrings.money_format);
        form.querySelector('.price-lable .max').innerHTML = Shopify.formatMoney(Math.round(high * 100), cartStrings.money_format);
      };
      const apply = changed => {
        sync(changed);
        const params = new URLSearchParams(window.location.search);
        params.delete('page'); params.delete('section_id');
        params.set(minPrice.name, minPrice.value);
        params.set(maxPrice.name, maxPrice.value);
        this.renderSectionFilter(this.renderUrl(params.toString()), params.toString());
      };
      minPrice.addEventListener('change', () => apply(minPrice));
      maxPrice.addEventListener('change', () => apply(maxPrice));
      [minRange, maxRange].forEach(range => {
        const input = range === minRange ? minPrice : maxPrice;
        range.addEventListener('input', () => { input.value = range.value; sync(input); });
        range.addEventListener('change', () => apply(input));
      });
      form.addEventListener('submit', event => { event.preventDefault(); apply(minPrice); });
    },

    removeParam: function (key, sourceURL) {
      var rtn = sourceURL.split('?')[0],
        param,
        params_arr = [],
        queryString =
          sourceURL.indexOf('?') !== -1 ? sourceURL.split('?')[1] : '';
      if (queryString !== '') {
        params_arr = queryString.split('&');
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
          param = params_arr[i].split('=')[0];
          if (param === key) {
            params_arr.splice(i, 1);
          }
        }
        if (params_arr.length) rtn = rtn + '?' + params_arr.join('&');
      }
      return rtn;
    },

    renderUrl: function (searchParams) {
      const sectionId = document.querySelector(options_collection.section)
        .dataset.sectionId;
      const url = `${window.location.pathname}?section_id=${sectionId}&${searchParams}`;
      return url;
    },

    renderSectionFilter: async function (url, searchParams, options = {}) {
      const requestId = (this.requestId || 0) + 1;
      this.requestId = requestId;
      this.filterController?.abort();
      const controller = new AbortController();
      this.filterController = controller;
      const destination = new URL(url, window.location.href);
      destination.searchParams.delete('section_id');
      if (!options.history) destination.searchParams.delete('page');
      const request = new URL(destination.href);
      const current = document.querySelector(options_collection.section);
      request.searchParams.set('section_id', current.dataset.sectionId);
      this.toggleLoading(document.body, true);
      try {
        const response = await fetch(request.href, {signal: controller.signal});
        if (!response.ok) throw new Error('Could not load filtered products');
        const html = await response.text();
        if (requestId !== this.requestId) return;
        const next = new DOMParser().parseFromString(html, 'text/html').querySelector(options_collection.section);
        if (!next) throw new Error('Missing product section');
        document.querySelector(options_collection.section).replaceWith(next);
        document.documentElement.classList.remove('hside_opened', 'open-drawer', 'open-sidebar');
        root.style.removeProperty('padding-right');
        if (!options.history) this.updateUrl(destination.href);
        this.ionRangeSlider();
        const motion = document.querySelector('.motion-collection');
        motion?.reloadAnimationEffect?.();
        initLazyloadItem(); BlsLazyloadImg.init();
        const grid = document.querySelector(options_collection.productgridcontainer);
        if (grid && !options.history) window.scrollTo({top: grid.getBoundingClientRect().top + window.pageYOffset - 100, behavior: 'smooth'});
      } catch (error) {
        if (error.name === 'AbortError' || requestId !== this.requestId) return;
        const message = document.querySelector('.broek-filter-error');
        if (message) message.hidden = false;
      } finally {
        if (requestId === this.requestId) this.toggleLoading(document.body, false);
      }
    },

    toggleLoading: function (event, loading) {
      this._loading = loading;
      if (event) {
        if (loading) {
          event.classList.add('start', 'loading');
        } else {
          event.classList.add('finish');
          setTimeout(function () {
            if (eventCollectionShopify.filterController && !eventCollectionShopify.filterController.signal.aborted && eventCollectionShopify._loading) return;
            event.classList.remove('start', 'loading', 'finish');
          }, 500);
        }
      }
    },

    updateUrl: function (url, searchParams = false) {
      if (searchParams) {
        const urlUpdate = `${window.location.pathname}?${searchParams}`;
        window.history.pushState({ url: urlUpdate }, '', urlUpdate);
      } else {
        window.history.pushState({ url: url }, '', url);
      }
    },
  };
})();
eventCollectionShopify.init();

window.addEventListener('popstate', () => { if (document.querySelector(options_collection.section)) eventCollectionShopify.renderSectionFilter(window.location.href, null, {history: true}); });
